import { render } from "./air_temperature.vue?vue&type=template&id=019e1dd9"
import script from "./air_temperature.vue?vue&type=script&lang=js"
export * from "./air_temperature.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__